export default "__VITE_ASSET__c551176f__"